import { useEffect, useState } from "react";
import { http } from "@/lib/api";

// Lote 126 — valores já cadastrados (comarcas, varas, partes, apelidos, números CNJ, clientes) para o
// preenchimento automático dos campos. Uma só consulta leve, compartilhada, com cache de 5 min;
// `invalidarSugestoes()` depois de cadastrar algo novo.
const VAZIO = { comarcas: [], varas: [], partes: [], apelidos: [], numeros: [], clientes: [] };
const cache = { dados: null, ts: 0, promise: null };

export function invalidarSugestoes() {
  cache.ts = 0;
}

export default function useSugestoes() {
  const [dados, setDados] = useState(cache.dados || VAZIO);
  useEffect(() => {
    let vivo = true;
    if (cache.dados && Date.now() - cache.ts < 300000) { setDados(cache.dados); return () => {}; }
    if (!cache.promise) {
      cache.promise = http.get("/sugestoes")
        .then((r) => {
          const d = r.data && typeof r.data === "object" ? { ...VAZIO, ...r.data } : VAZIO;
          cache.dados = d; cache.ts = Date.now();
          return d;
        })
        .catch(() => cache.dados || VAZIO)
        .finally(() => { cache.promise = null; });
    }
    cache.promise.then((d) => { if (vivo) setDados(d); });
    return () => { vivo = false; };
  }, []);
  return dados;
}
